import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const SubscribeModalBackground = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="modal-background" />

      <style jsx>{`
        .modal-background {
          background: #ffffff url(${theme.images.lightbox.subscribe}) no-repeat;
          background-size: cover;
          border-radius: 6px;
          bottom: 0;
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 0;
        }
        .modal-background:after {
          background: rgba(0, 0, 0, 0.6);
          border-radius: 6px;
          bottom: 0;
          content: '';
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
          z-index: 1;
        }

        @media (min-width: ${theme.breakpoints.mdUp}) {
          .modal-background {
            background-image: url(${theme.images.lightbox.popeye});
          }
          .modal-background:after {
            background: transparent;
          }
        }
      `}</style>
    </>
  );
};

export default SubscribeModalBackground;
